const frontImages = require.context('../TCG/One_Piece', true, /\/front\.(webp|png|jpg)$/i)


const OnePieceProduct = [
  { id: 'Royal_Blood_Booster_Box_OP10', name: 'Royal Blood Booster Box OP-10', imageExt: '.webp', inStock: 0, weight: 1.5, price: 5188.8 },
  { id: 'Two_Legends_Booster_Box_OP08', name: 'Two Legends Booster Box OP-08', imageExt: '.webp', inStock: 0, weight: 1.5, price: 5333.01 },
  { id: 'One_Piece_TCG_Special_Goods_Set_AceSaboLuffy', name: 'One Piece TCG - Special Goods Set -Ace/Sabo/Luffy', imageExt: '.webp', inStock: 0, weight: 1, price: 1236.71 },
  { id: 'The_Best_Premium_Booster_Display_PRB02', name: 'The Best - Premium Booster Display [PRB-02]', imageExt: '.webp', inStock: 0, weight: 2, price: 7350.8 },
  { id: 'OP14_The_Azure_Seas_Seven_Booster_Display_ENG', name: 'OP-14 - The Azure Sea\'s Seven - Booster Display - ENG', imageExt: '.webp', inStock: 0, weight: 1.5, price: 5909.39 },
  { id: 'One_Piece_TCG_EggHead_ST29_Starter_Deck', name: 'One Piece TCG - EggHead ST-29 Starter Deck', imageExt: '.webp', inStock: 0, weight: 0.3, price: 807.07 },
  { id: 'One_Piece_Card_Game_Premium_Card_Collection_Live_Action_Edition', name: 'One Piece Card Game: Premium Card Collection - Live Action Edition', imageExt: '.webp', inStock: 0, weight: 1, price: 1325.95 },
  { id: 'OP15EB04_Adventure_on_Kamis_Island_Booster_Display_ENG_24_packs', name: 'OP15-EB04 - Adventure on Kami\'s Island - Booster Display - ENG (24 packs)', imageExt: '.webp', inStock: 0, weight: 2, price: 7177.84 },
  { id: 'ST25_Starter_Deck_Blue_Buggy', name: 'ST25 Starter Deck - Blue Buggy', imageExt: '.webp', inStock: 0, weight: 0.3, price: 533.37 },
  { id: 'OP16_The_Time_of_Battle_Booster_Display_ENG', name: 'OP-16 - The Time of Battle - Booster Display - ENG', imageExt: '.webp', inStock: 0, weight: 1.5, price: 5188.8 },
]

const _assignTcgCategory = (name) => {
  const n = name.toLowerCase()
  if (/booster\s*(box|display|pack)/.test(n)) return 'Booster Pack'
  if (/one\s*piece\b/.test(n) && /case|display/.test(n)) return 'Booster Display'
  if (/deck\b|2[\s-]?player.*set|play\s*mat.*set/.test(n)) return 'Decks'
  if (/booster/.test(n)) return 'Booster Pack'
  return 'Other'
}

OnePieceProduct.forEach(function(p) {
  p.category = _assignTcgCategory(p.name)
  try {
    p.image = frontImages('./' + p.id + '/front' + p.imageExt)
  } catch (e) {
    p.image = null
  }
})

export { OnePieceProduct }
